module.exports = __webpack_public_path__ + "static/media/africa.349c77b7.svg";